export const ADDRESS_SEARCH_AUTOCOMPLETE = 'ADDRESS_SEARCH_AUTOCOMPLETE'
export const ADDRESS_SEARCH_AUTOCOMPLETE_SUCCESS = 'ADDRESS_SEARCH_AUTOCOMPLETE_SUCCESS'
export const ADDRESS_SEARCH_AUTOCOMPLETE_FAILED = 'ADDRESS_SEARCH_AUTOCOMPLETE_FAILED'

export const ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE = 'ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE'
export const ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_SUCCESS = 'ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_SUCCESS'
export const ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_FAILED = 'ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_FAILED'

export const ADDRESS_SEARCH_ID_AUTOCOMPLETE = 'ADDRESS_SEARCH_ID_AUTOCOMPLETE'
export const ADDRESS_SEARCH_ID_AUTOCOMPLETE_SUCCESS = 'ADDRESS_SEARCH_ID_AUTOCOMPLETE_SUCCES'
export const ADDRESS_SEARCH_ID_AUTOCOMPLETE_FAILED = 'ADDRESS_SEARCH_ID_AUTOCOMPLETE_FAILED'
